<template>
  <Modal
    width="920"
    :title="title"
    class-name="c-select-label vertical-center-modal"
    v-model="visiable"
    :closable="false"
    :mask-closable="false"
    :transfer="transfer"
    @on-ok="save"
    @on-visible-change="bindGetData"
  >
    <!-- <Spin size="large" fix v-if="loading"></Spin> -->
    <Row class="filter-box" :gutter="12" v-if="visiable">
      <Col span="6">
        <Input v-model="keyword" placeholder="请输入创意标签组名称或ID" search />
      </Col>
      <Col span="7">
        <Form :label-width="60">
          <drop-autoComplete label="创建人" member :default-option="defaultOpenId" @on-change="changeOperator"></drop-autoComplete>
        </Form>
      </Col>
    </Row>
    <el-table ref="table" border v-loading="loading" :height="450" :data="labelData">
      <el-table-column type="selection" width="47">
        <template slot-scope="scope">
          <Checkbox
            :indeterminate="indeterminate(scope.row.labels)"
            :value="checkAll(scope.row.labels)"
            @click.prevent.native="handleCheckAll(checkAll(scope.row.labels), scope.row.labels)"
          />
        </template>
      </el-table-column>
      <el-table-column
        v-for="(col, id) in columns"
        :key="id"
        :prop="col.key"
        :label="col.title"
        :min-width="col.width"
        :sortable="col.sortable"
        :fixed="col.fixed"
        :show-overflow-tooltip="col.overflow"
        :formatter="col.format"
        :sort-orders="['descending', 'ascending', null]"
      >
        <template slot-scope="scope">
          <div class="c-label-box" v-if="col.key === 'labels'">
            <template v-for="(item, index) in scope.row[col.key]">
              <Checkbox v-model="item.check" :key="index">{{ item.name }}</Checkbox>
            </template>
          </div>
          <span v-else>{{ scope.row[col.key] }}</span>
        </template>
      </el-table-column>
    </el-table>
    <Page
      v-if="labelData.length"
      :current.sync="pageIndex"
      :total="total"
      :page-size="pageSize"
      show-total
      show-sizer
      show-elevator
      :page-size-opts="[10, 20, 30, 40, 100]"
      @on-change="changePageIndex"
      class="page-index"
    />
  </Modal>
</template>
<script>
import Cookies from 'js-cookie'
import { setLocal, getLocal } from '@/common/js/api'
import { isArray, isEmpty, trim } from '@/common/js/utils'
import { listCreativeLable } from '@/api/manage.model'
import DropAutoComplete from '@/components/dropdown/'

const columns = [
  {
    title: 'ID',
    key: 'id',
    width: 56
  },
  {
    title: '创意标签组',
    key: 'title',
    width: 80
  },
  {
    title: '创意标签',
    key: 'labels',
    width: 400
  },
  {
    title: '创建人',
    key: 'opName',
    width: 74
  }
]

export default {
  name: 'selectLabel',
  components: {
    DropAutoComplete
  },
  props: {
    transfer: {
      type: Boolean,
      default: false
    },
    value: {
      type: Boolean
    },
    openId: {
      type: [Number, String]
    }
  },
  computed: {
    visiable: {
      get() {
        return this.value
      },
      set(val) {
        this.$emit('input', val)
      }
    },
    selectLabels() {
      const getConcat = (sum, item) => {
        return sum.concat(item)
      }
      return this.labelData.map((ret) => ret.labels.filter((met) => met.check)).reduce(getConcat, [])
    },
    len() {
      return this.selectLabels.length
    },
    title() {
      return `选择创意标签  ${this.len ? '(已选' + this.len + '条)' : ''}`
    },
    // 全选状态
    checkAll() {
      return (data) => {
        return data.every((ret) => ret.check)
      }
    },
    // 半选状态
    indeterminate() {
      return (data) => {
        return data.some((ret) => ret.check) && !data.every((ret) => ret.check)
      }
    }
  },
  methods: {
    bindGetData(val) {
      if (!val) {
        this.keyword = ''
        this.pageIndex = 1
        this.pageSize = 10
        this.labelData = []
      } else {
        this.setOpenId()
        this.getData()
      }
    },
    getData() {
      const params = {
        pageId: this.pageIndex,
        pageSize: this.pageSize,
        keyword: trim(this.keyword),
        opId: this.opId
      }

      this.loading = true
      listCreativeLable(params).then((data) => {
        this.loading = false
        if (!data) return false
        const { list, page_info } = data
        if (isArray(list)) {
          this.labelData = list.map((ret) => {
            ret.labels = isArray(ret.labelDetailList) ? ret.labelDetailList.map((met) => ({ name: met, check: false })) : []
            return ret
          })
        }
        if (page_info) {
          const { total_number } = page_info
          this.total = total_number || 0
        }
      })
    },
    setOperatorStorage(name, value) {
      const account = this.openId || Cookies.get('ch_op_id')
      const storage = getLocal(name) || {}
      if (account) {
        storage[account] = value
        setLocal(name, storage)
      }
    },
    setOpenId() {
      const account = this.openId || ''
      const storage = getLocal('select-label')
      this.defaultOpenId = storage && storage[account] ? storage[account] : account
    },
    changeOperator(meta) {
      if (meta && meta.id !== this.opId) {
        this.pageIndex = 1
        this.opId = meta && meta.id
        this.getData()
      } else if (isEmpty(meta) && this.opId) {
        this.pageIndex = 1
        this.opId = -1
        this.getData()
      }
    },
    changePageIndex(index) {
      this.pageIndex = index
      this.getData()
    },
    // 全选操作
    handleCheckAll(check, labels) {
      if (!isArray(labels)) return
      labels.forEach((ret) => {
        this.$set(ret, 'check', !check)
      })
    },
    save() {
      if (this.len) {
        // 记录上次成功opId
        this.setOperatorStorage('select-label', this.opId || -1)
        this.$emit(
          'on-select',
          this.selectLabels.filter((met, i) => this.selectLabels.findIndex((ret) => met.name === ret.name) === i)
        )
      } else this.$Message.warning('您未选择一个创意标签')
    }
  },
  data() {
    return {
      loading: null,
      keyword: '',
      pageIndex: 1,
      pageSize: 10,
      total: 0,
      columns: columns,
      labelData: [], // 标签列表
      defaultOpenId: ''
    }
  },
  watch: {
    keyword(nVal) {
      this.getData()
    }
  },
  created() {
    this.setOpenId()
  }
}
</script>

<style lang="scss" scoped>
::v-deep .c-select-label {
  .filter-box {
    margin-bottom: 15px;

    .ivu-form-item {
      margin-bottom: 0;
    }
  }

  .page-index {
    margin-top: 12px;
    text-align: right;
  }

  .el-input {
    font-size: 12px;
  }

  /* 表格表头 */
  .el-table td {
    padding: 6px 0;
  }

  /* 表格背景 */
  .el-table th {
    background-color: #f2f2f2;
  }

  .el-table .cell {
    font-size: 12px;
  }

  .el-table {
    th.el-table-column--selection {
      position: relative;

      &.is-leaf {
        .cell {
          display: none !important;
        }
      }
    }

    .ivu-checkbox-wrapper .ivu-checkbox {
      margin-right: 0;
    }
  }
}
</style>
